"use strict";

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

exports.__esModule = true;
exports.DsDropZone = void 0;

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("./DsDropZone.css");

var _react = _interopRequireWildcard(require("react"));

var _reactDropzone = require("react-dropzone");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CompactDropZone = function CompactDropZone(_ref) {
  var id = _ref.id,
      inputProps = _ref.inputProps,
      dragLabel = _ref.dragLabel,
      selectLabel = _ref.selectLabel,
      fileLabel = _ref.fileLabel;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      height: '100%'
    },
    role: "document",
    "aria-label": "file upload zone",
    className: "position-relative d-block bg-lvl1",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "sgm-docs-upload-squares"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "upload-inner text-center py-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
        className: "icon icon-xl text-light",
        children: "attach_file"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        className: "text-secondary px-4 line-height-1",
        children: [dragLabel, ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          htmlFor: "inputfile-compact-" + id,
          className: "btn btn-link text-info px-0 mb-0",
          children: selectLabel
        }), ' ', fileLabel]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", Object.assign({
        className: "d-none",
        type: "file",
        name: "inputfile-compact-" + id,
        id: "inputfile-compact-" + id
      }, inputProps))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "sgm-docs-upload-squares"
    })]
  });
};

var SmallDropZone = function SmallDropZone(_ref2) {
  var id = _ref2.id,
      inputProps = _ref2.inputProps,
      dragLabel = _ref2.dragLabel,
      selectLabel = _ref2.selectLabel,
      fileLabel = _ref2.fileLabel;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      height: '100%'
    },
    role: "document",
    "aria-label": "file upload zone",
    className: "position-relative d-block bg-lvl1",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "sgm-docs-upload-squares"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "upload-inner py-3 text-center d-flex align-items-center justify-content-start",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
        className: "icon icon-xl text-light mx-5",
        children: "attach_file"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        className: "text-secondary m-0 line-height-1",
        children: [dragLabel, ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          htmlFor: "inputfile-small-" + id,
          className: "btn btn-link text-info px-0 mb-0",
          children: selectLabel
        }), ' ', fileLabel]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", Object.assign({
        className: "d-none",
        type: "file",
        name: "inputfile-small-" + id,
        id: "inputfile-small-" + id
      }, inputProps))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "sgm-docs-upload-squares"
    })]
  });
};

var MediumDropZone = function MediumDropZone(_ref3) {
  var id = _ref3.id,
      inputProps = _ref3.inputProps,
      addLabel = _ref3.addLabel,
      dragLabel = _ref3.dragLabel,
      selectLabel = _ref3.selectLabel,
      fileLabel = _ref3.fileLabel;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      height: '100%'
    },
    role: "document",
    "aria-label": "file upload zone",
    className: "position-relative d-block bg-lvl1",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "sgm-docs-upload-squares"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "upload-inner text-center py-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
        className: "icon icon-xl text-light",
        children: "attach_file"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "h4 mb-2 text-secondary fw-medium",
        children: addLabel
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        className: "text-secondary line-height-1",
        children: [dragLabel, ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          htmlFor: "inputfile-medium-" + id,
          className: "btn btn-link text-info px-0 mb-0",
          children: selectLabel
        }), ' ', fileLabel]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", Object.assign({
        className: "d-none",
        type: "file",
        name: "inputfile-medium-" + id,
        id: "inputfile-medium-" + id
      }, inputProps))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "sgm-docs-upload-squares"
    })]
  });
};

var LargeDropZone = function LargeDropZone(_ref4) {
  var id = _ref4.id,
      inputProps = _ref4.inputProps,
      addLabel = _ref4.addLabel,
      dragLabel = _ref4.dragLabel,
      selectLabel = _ref4.selectLabel,
      fileLabel = _ref4.fileLabel,
      browseLabel = _ref4.browseLabel;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      height: '100%'
    },
    role: "document",
    "aria-label": "file upload zone",
    className: "position-relative d-block bg-lvl1",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "sgm-docs-upload-squares"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "upload-inner h-100 d-flex flex-column justify-content-center text-center pb-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
        className: "icon icon-xl text-light",
        children: "attach_file"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "h4 mb-2 text-secondary fw-medium",
        children: addLabel
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        className: "text-secondary line-height-1",
        children: [dragLabel, ' ', selectLabel, ' ', fileLabel]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
        htmlFor: "inputfile-large-" + id,
        className: "btn btn-primary mb-0",
        style: {
          maxWidth: 'fit-content',
          margin: '0 auto'
        },
        children: browseLabel
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", Object.assign({
        className: "d-none",
        type: "file",
        name: "inputfile-large-" + id,
        id: "inputfile-large-" + id
      }, inputProps))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "sgm-docs-upload-squares"
    })]
  });
};

var DsDropZone = function DsDropZone(_ref5) {
  var _ref5$type = _ref5.type,
      type = _ref5$type === void 0 ? 'large' : _ref5$type,
      onSelectedFiles = _ref5.onSelectedFiles,
      _ref5$addLabel = _ref5.addLabel,
      addLabel = _ref5$addLabel === void 0 ? 'Add attachment' : _ref5$addLabel,
      _ref5$dragLabel = _ref5.dragLabel,
      dragLabel = _ref5$dragLabel === void 0 ? 'Drag or' : _ref5$dragLabel,
      _ref5$selectLabel = _ref5.selectLabel,
      selectLabel = _ref5$selectLabel === void 0 ? 'select' : _ref5$selectLabel,
      _ref5$fileLabel = _ref5.fileLabel,
      fileLabel = _ref5$fileLabel === void 0 ? 'your file to this area to upload' : _ref5$fileLabel,
      _ref5$browseLabel = _ref5.browseLabel,
      browseLabel = _ref5$browseLabel === void 0 ? 'Browse file' : _ref5$browseLabel;
  var uniqueIdRef = (0, _react.useRef)(("" + Math.random()).replace('0.', ''));

  var _useDropzone = (0, _reactDropzone.useDropzone)({
    onDrop: function onDrop(files) {
      return onSelectedFiles(files);
    }
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps;

  switch (type) {
    case 'large':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", Object.assign({
        style: {
          height: '100%'
        }
      }, getRootProps({
        onClick: function onClick(evt) {
          return evt.preventDefault();
        }
      }), {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(LargeDropZone, {
          id: uniqueIdRef.current,
          addLabel: addLabel,
          dragLabel: dragLabel,
          selectLabel: selectLabel,
          fileLabel: fileLabel,
          browseLabel: browseLabel,
          inputProps: getInputProps()
        })
      }));

    case 'medium':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", Object.assign({
        style: {
          height: '100%'
        }
      }, getRootProps({
        onClick: function onClick(evt) {
          return evt.preventDefault();
        }
      }), {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(MediumDropZone, {
          id: uniqueIdRef.current,
          addLabel: addLabel,
          dragLabel: dragLabel,
          selectLabel: selectLabel,
          fileLabel: fileLabel,
          inputProps: getInputProps()
        })
      }));

    case 'small':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", Object.assign({
        style: {
          height: '100%'
        }
      }, getRootProps({
        onClick: function onClick(evt) {
          return evt.preventDefault();
        }
      }), {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SmallDropZone, {
          id: uniqueIdRef.current,
          dragLabel: dragLabel,
          selectLabel: selectLabel,
          fileLabel: fileLabel,
          inputProps: getInputProps()
        })
      }));

    case 'compact':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", Object.assign({
        style: {
          height: '100%'
        }
      }, getRootProps({
        onClick: function onClick(evt) {
          return evt.preventDefault();
        }
      }), {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(CompactDropZone, {
          id: uniqueIdRef.current,
          dragLabel: dragLabel,
          selectLabel: selectLabel,
          fileLabel: fileLabel,
          inputProps: getInputProps()
        })
      }));

    default:
      throw new Error("Type should be large, medium, compact or small");
  }
};

exports.DsDropZone = DsDropZone;